import React, { useState, useEffect } from 'react';
import { Search, Mail, Phone, FileText } from 'lucide-react';
import { getCandidatos } from '../api';

const CandidatosGlobalList = () => {
  const [candidatos, setCandidatos] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const fetchCandidatos = async () => {
      try {
        const res = await getCandidatos();
        setCandidatos(res.data);
      } catch (err) {
        console.error("Error al obtener candidatos", err);
      }
    };
    fetchCandidatos();
  }, []);

  const filtered = candidatos.filter(c => 
    c.nombre.toLowerCase().includes(searchTerm.toLowerCase()) || 
    c.email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="p-8 w-full max-w-7xl mx-auto flex flex-col h-full">
      <h1 className="text-2xl font-bold text-gray-800 uppercase tracking-wider mb-6">Base Global de Candidatos</h1>

      <div className="bg-white p-4 rounded-t-lg shadow-sm flex items-center border border-gray-200 border-b-0 w-full md:w-1/2">
        <label className="text-sm font-bold text-gray-500 mr-4">Buscar:</label>
        <div className="flex-1 flex items-center border rounded px-3 py-1 text-gray-400 focus-within:border-emeral-green transition">
          <Search size={14} />
          <input 
            type="text" 
            placeholder="Nombre, email..." 
            className="ml-2 outline-none w-full text-sm text-gray-700" 
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      <div className="bg-white border rounded-lg rounded-tl-none shadow-sm overflow-hidden flex-1 overflow-y-auto">
        <table className="w-full text-left border-collapse">
          <thead className="bg-[#00a99d] text-white sticky top-0 z-10">
            <tr>
              <th className="p-3 text-xs font-bold uppercase tracking-wider pl-6">Nombre</th>
              <th className="p-3 text-xs font-bold uppercase tracking-wider">Contacto</th>
              <th className="p-3 text-xs font-bold uppercase tracking-wider">Etapa Actual</th>
              <th className="p-3 text-xs font-bold uppercase tracking-wider text-center">Proceso (ID)</th>
              <th className="p-3 text-xs font-bold uppercase tracking-wider text-center">Docs</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {filtered.length === 0 ? (
              <tr>
                <td colSpan="5" className="p-8 text-center text-gray-400">No hay candidatos que coincidan con la búsqueda.</td>
              </tr>
            ) : filtered.map(c => (
              <tr key={c.id} className="hover:bg-green-50 transition-colors">
                <td className="p-3 pl-6 font-bold text-sm text-gray-800">{c.nombre}</td>
                <td className="p-3 text-sm text-gray-500">
                  <div className="flex flex-col gap-1">
                    <span className="flex items-center gap-1 text-xs"><Mail size={12}/> {c.email}</span>
                    {c.telefono && <span className="flex items-center gap-1 text-xs"><Phone size={12}/> {c.telefono}</span>}
                  </div>
                </td>
                <td className="p-3">
                  <span className="inline-block px-2 py-1 bg-gray-100 text-gray-600 rounded text-xs font-semibold">{c.etapa_actual}</span>
                </td>
                <td className="p-3 text-xs font-medium text-gray-500 text-center">
                  {c.ProcesoId || '-'}
                </td>
                <td className="p-3 text-center">
                  {c.cv_url ? (
                    <a href={`http://localhost:5000${c.cv_url}`} target="_blank" rel="noreferrer" className="inline-flex text-[#00a99d] hover:bg-[#00a99d]/10 px-2 py-1 rounded" title="Ver CV">
                      <FileText size={18}/>
                    </a>
                  ) : <span className="text-gray-300">-</span>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CandidatosGlobalList;
